/** NDT method choices for Statement of Work → Pipeline Section creation (Add New Pipeline modal). */
export const NDT_PIPELINE_TYPE_OPTIONS = [
  { value: 'RT', label: 'RT (Radiographic Testing)' },
  { value: 'AUT', label: 'AUT (Automated Ultrasonic Testing)' },
  { value: 'Both', label: 'Both (RT & AUT)' },
];
